export interface SharingEmailState {
  head: string;
  body: string;
}

export const initialState: SharingEmailState = {
  head: "You're invited! 💌Check out {NAME}'s dress matches",
  body: "Hello, beautiful! I just took the wedding dress quiz from David's Bridal and wanted to share these gorgeous gowns. Think one might be THE dress? Take a look...\n{LINK}",
};

export function sharingEmailReducer(state = initialState): SharingEmailState {
  return state;
}
